import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';
import { FinancialArea, FinancialDataPayload, FinancialData } from '../models';
import { ListResponse } from '../interfaces';

@Injectable()
export class FinancialDataService extends BaseService<FinancialArea> {
  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getFinancialAreas(): Observable<ListResponse<FinancialArea>> {
    const apiUrl = `${this.getResourceUrl()}financial-areas/`;

    return this.http.get<ListResponse<FinancialArea>>(apiUrl);
  }

  public getFinancialData(
    entityId: number,
    financialAreaId: number,
    financialDataObjectTypeId: number): Observable<ListResponse<FinancialData>> {
    const apiUrl = `${this.getResourceUrl()}${entityId}/area/${financialAreaId}/type/${financialDataObjectTypeId}`;

    return this.http.get<ListResponse<FinancialData>>(apiUrl);
  }

  public saveFinancialData(
    entityId: number,
    financialAreaId: number,
    financialDataObjectTypeId: number,
    payload: FinancialDataPayload): Observable<ListResponse<FinancialData>> {
    const apiUrl = `${this.getResourceUrl()}${entityId}/area/${financialAreaId}/type/${financialDataObjectTypeId}`;

    return this.http.post<ListResponse<FinancialData>>(apiUrl, payload);
  }

  protected getResourceUrl(): string {
    return this.baseUrl + 'financial-data/';
  }
}
